import React, { Component } from 'react'
import { TextField } from 'material-ui'

class StaticTextInput extends Component {
  getValue() {
    return this.refs.input.getValue()
  }

  render() {
    const {
      header,
      type = 'text',
      value,
      onChange = () => {},
      defaultValue = '',
      disabled,
      width = 256,
      maxLength,
      marginLeft = 0
    } = this.props
    const { underlineStyle, hintStyle } = styles
    return (
      <TextField
        ref={'input'}
        underlineFocusStyle={underlineStyle}
        underlineStyle={underlineStyle}
        hintStyle={hintStyle}
        inputStyle={hintStyle}
        hintText={header}
        type={type}
        value={value}
        onChange={(event, newValue) => onChange(newValue)}
        defaultValue={defaultValue}
        disabled={disabled}
        style={{ width, marginLeft }}
        maxLength={maxLength}
      />
    )
  }
}

const styles = {
  underlineStyle: {
    borderColor: '#ffffff'
  },
  hintStyle: {
    color: '#ffffff'
  }
}

export { StaticTextInput }



// WEBPACK FOOTER //
// ./src/components/common/StaticTextInput.js